// extracted by mini-css-extract-plugin
module.exports = {"notificationsBadge":"NotificationsBadge_notificationsBadge__ASTip"};